import { render } from "./UserMenuComponent.vue?vue&type=template&id=56068553"
import script from "./UserMenuComponent.vue?vue&type=script&lang=js"
export * from "./UserMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__